module.exports = __webpack_public_path__ + "static/img/pic1.b7d21188.png";